/**
 * Extract the src value from an imported image. This is a workaround for
 * WebPack configurations importing the path to the image, but Next.js importing
 * an object.
 *
 * @example
 * 	import image from "./image.png";
 * 	<img src={image} alt=""> //This will work without the function in WebPack, but not Next.js.
 * 	<img src={extractSource(image)} alt=""> //This will work in both.
 *
 * @param image The imported image to extract the source from.
 * @returns The source of the image.
 */
export function extractSource(image) {
    if (typeof image === "string") {
        return image;
    }
    return image.src;
}
